"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizationValues = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const countries_1 = require("../config/countries");
const currency_1 = require("../config/currency");
const language_1 = require("../config/language");
const validationsData_1 = require("./validationsData");
/**
 * Получаем данные из кук (с бэка)
 */
const getLocalizationValues = () => {
    const country = js_cookie_1.default.get('cnt') || countries_1.defaultCountry;
    const language = js_cookie_1.default.get('lang') || language_1.defaultLanguage;
    const currencyCode = js_cookie_1.default.get('cur') || currency_1.defaultCurrency;
    try {
        const validCurrencyCode = (0, validationsData_1.validateCurrencyCode)(currencyCode);
        const validLanguage = (0, validationsData_1.validateLanguage)(language);
        const validCountry = (0, validationsData_1.validateCountry)(country);
        return {
            country: validCountry,
            language: validLanguage,
            currencyCode: validCurrencyCode,
        };
    }
    catch (err) {
        console.error(err);
        return {
            country: countries_1.defaultCountry,
            language: language_1.defaultLanguage,
            currencyCode: currency_1.defaultCurrency
        };
    }
};
exports.getLocalizationValues = getLocalizationValues;
